import { VSkeletonLoader } from 'vuetify/lib';

export default {
  extends: VSkeletonLoader,
};
